import { DATE_FORMATS } from '@constants/general';
import { formatDate } from '@helpers/date';

/**
 * Formats API date into correct string for frontend display
 * @param {string} date Date from API
 * @returns {string}
 */
export const formatRegDate = date =>
  formatDate(date, DATE_FORMATS.REG_PAGE.DATE_FORMAT, DATE_FORMATS.REG_PAGE.DISPLAY_DATE_FORMAT);
